import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Staging-only: proactively unregister any existing service worker and clear caches
if (import.meta.env.VITE_ENVIRONMENT === 'staging') {
  // Do this only once to avoid reload loops
  const mark = '__staging_sw_cleanup_done__'
  try {
    if (typeof window !== 'undefined' && !localStorage.getItem(mark)) {
      ;(async () => {
        try {
          if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations()
            await Promise.all(regs.map(r => r.unregister()))
          }
          if ('caches' in window) {
            const keys = await caches.keys()
            await Promise.all(keys.map(k => caches.delete(k)))
          }
          localStorage.setItem(mark, '1')
          // Reload once to ensure fresh assets are served without SW
          window.location.reload()
        } catch (e) {
          console.warn('Staging SW cleanup error:', e)
        }
      })()
    }
  } catch (e) {
    console.warn('Staging SW cleanup flag error:', e)
  }
}



ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)